import React, { useRef, useState } from 'react';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import Heading from '../../components/common/Heading/Heading';
import { App, Button, Input, Popconfirm, Popover, Space, Tag } from 'antd';
import { MdDelete, MdModeEditOutline } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import {SearchOutlined} from '@ant-design/icons';
import {
  deletePractitioner,
  getPractitioners,
} from '../../network/practitioners';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../../services/react-query/queryKeys';
import { useSelector } from 'react-redux';
import StatusTag from '../../hooks/StatusHook';
import { colorPrimary } from '../../utils/utils';

const Practitioners = ({ t }) => {
  const client = useQueryClient();
  const navigate = useNavigate();
  const searchInputMobile = useRef(null);
  const searchInput = useRef(null);
  const { message } = App.useApp();
  const [searchText, setSearchText] = useState({
    value: '',
    key: ''});
  const [textValue,setTextValue] = useState('');
  const handleRemove = useMutation(
    // (id) => deletePatient(id),
    {
      mutationFn: (id) => deletePractitioner(id),
      onSuccess: (data) => {
        // console.log(data, 'data');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(data?.message?.message);
        // message.success('تم الحذف بنجاح');
        client.invalidateQueries({ queryKey: [queryKeys.practitioners] });
      },
      onError: () => {
        message.error('حدث خطأ ما');
      },
    }
  );
    const handleSearch = (selectedKeys, confirm, dataIndex) => {
      confirm();
      setSearchText({ value: selectedKeys[0], key: dataIndex });
    };
    const handleReset = (clearFilters, confirm) => {
      confirm();
      setTextValue('');
      clearFilters();
      setSearchText({ value: '', key: '' });
    };
  const { currentLang } = useSelector((state) => state.user);
  const columns = [
    {
      title: t.practitionerNo,
      dataIndex: 'name',
      filterIcon: () => <SearchOutlined color={colorPrimary} />,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div
          style={{
            padding: 8,
          }}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <Input
            ref={searchInputMobile}
            placeholder={t.mobile}
            value={textValue}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              setTextValue(e.target.value);
            }}
            onPressEnter={() => handleSearch(selectedKeys, confirm, 'name')}
            style={{
              marginBottom: 8,
              display: 'block',
            }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => handleSearch(selectedKeys, confirm, 'name')}
              icon={<SearchOutlined />}
              size="small"
              style={{
                width: 90,
              }}
            >
              {t.Search}
            </Button>
            <Button
              onClick={() => clearFilters && handleReset(clearFilters, confirm)}
              size="small"
              style={{
                width: 90,
              }}
            >
              {t.Reset}
            </Button>
          </Space>
        </div>
      ),
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTextValue('');
          setSearchText({ value: '', key: '' });
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
      render: (text, record) => {
        return (
          <span
            style={{ cursor: 'pointer' }}
            className="text-primary"
            onClick={() => {
              navigate(`/practitioners/${record.name}`);
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: t.practitionerName,
      dataIndex: 'practitioner_name',
      filterIcon: () => <SearchOutlined color={colorPrimary} />,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div
          style={{
            padding: 8,
          }}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <Input
            ref={searchInputMobile}
            placeholder={t.mobile}
            value={textValue}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              setTextValue(e.target.value);
            }}
            onPressEnter={() => handleSearch(selectedKeys, confirm, 'practitioner_name')}
            style={{
              marginBottom: 8,
              display: 'block',
            }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => handleSearch(selectedKeys, confirm, 'practitioner_name')}
              icon={<SearchOutlined />}
              size="small"
              style={{
                width: 90,
              }}
            >
              {t.Search}
            </Button>
            <Button
              onClick={() => clearFilters && handleReset(clearFilters, confirm)}
              size="small"
              style={{
                width: 90,
              }}
            >
              {t.Reset}
            </Button>
          </Space>
        </div>
      ),
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTextValue('');
          setSearchText({ value: '', key: '' });
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    {
      title: t.gender,
      dataIndex: 'gender',
    },
    {
      title: t.mobile,
      dataIndex: 'mobile_phone',
      render: (text) => (
        <a href={`tel:${text}`} className="text-ltr">
          {text}
        </a>
      ),
      filterIcon: () => <SearchOutlined color={colorPrimary} />,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div
          style={{
            padding: 8,
          }}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <Input
            ref={searchInputMobile}
            placeholder={t.mobile}
            value={textValue}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              setTextValue(e.target.value);
            }}
            onPressEnter={() => handleSearch(selectedKeys, confirm, 'mobile_phone')}
            style={{
              marginBottom: 8,
              display: 'block',
            }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => handleSearch(selectedKeys, confirm, 'mobile_phone')}
              icon={<SearchOutlined />}
              size="small"
              style={{
                width: 90,
              }}
            >
              {t.Search}
            </Button>
            <Button
              onClick={() => clearFilters && handleReset(clearFilters, confirm)}
              size="small"
              style={{
                width: 90,
              }}
            >
              {t.Reset}
            </Button>
          </Space>
        </div>
      ),
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTextValue('');
          setSearchText({ value: '', key: '' });
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    {
      title: t.medicalDepartment,
      dataIndex: 'department',
      filterIcon: () => <SearchOutlined color={colorPrimary} />,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div
          style={{
            padding: 8,
          }}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <Input
            ref={searchInputMobile}
            placeholder={t.mobile}
            value={textValue}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              setTextValue(e.target.value);
            }}
            onPressEnter={() => handleSearch(selectedKeys, confirm, 'department')}
            style={{
              marginBottom: 8,
              display: 'block',
            }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => handleSearch(selectedKeys, confirm, 'department')}
              icon={<SearchOutlined />}
              size="small"
              style={{
                width: 90,
              }}
            >
              {t.Search}
            </Button>
            <Button
              onClick={() => clearFilters && handleReset(clearFilters, confirm)}
              size="small"
              style={{
                width: 90,
              }}
            >
              {t.Reset}
            </Button>
          </Space>
        </div>
      ),
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTextValue('');
          setSearchText({ value: '', key: '' });
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    {
      title: t.status,
      dataIndex: 'status',
      render: (status) => {
        return <StatusTag status={status} />;
      },
    },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      render: (text, record) => {
        // console.log('record:', record);
        return (
          <Space>
            <Popover
              placement="top"
              title={t.edit}
              onClick={() => navigate(`/practitioners/${record.name}`)}
            >
              <Button
                size="small"
                type="primary"
                // onClick={() => navigate(`/patients/${record.uid}`)}
              >
                <MdModeEditOutline />
              </Button>
            </Popover>
            <Popconfirm
              title={t.DeletethePractitioner}
              description={t.Areyousuretodeletethispractitioner}
              onConfirm={() => handleRemove.mutate(record.name)}
              okText={t.yes}
              cancelText={t.no}
            >
              <Button size="small" type="primary" danger>
                <MdDelete />
              </Button>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.practitioners,searchText.key,searchText.value],
    queryFn: () => getPractitioners({key:searchText.key, value:searchText.value}),
    keepPreviousData: true,
  });
  // console.log('data:', data);
  const dataTable = data?.data?.map((item, index) => {
    return {
      key: index,
      ...item,
    };
  });
  // if (isError) {
  //   console.log('error:', error);
  //   return message.error(error.message);
  // }
  return (
    <div className="practitioners">
      <Heading title={t.Healthcare} subTitle={t.practitioners} path="/" />
      <DynamicTableAnt
        columns={columns}
        data={dataTable}
        loading={isLoading}
        lang={currentLang}
        setSearchText={setSearchText}
        titleBtn={t.addPractitioner}
        Placeholder={t.Search + ' ' + t.practitionerName}
        pathBtn="/practitioners/add"
      />
    </div>
  );
};

export default Practitioners;
